import { GridColDef } from '@mui/x-data-grid'
import { RefernceValueFilter } from '../../../graphql/generated'
import { getNumberFormatter } from '../../../utils/adaptiveNumberFormat'

export type Row = {
  id: number | string // the row ID, which must be unique and stable for DataGrid
  supplierId?: string // supplier ID, or undefined for invoice groups
  name: string // e.g. supplier name, or invoice group name
  co2e: number // in kg
  kr: number
  intensity?: number | null // null to match GQL type
  krPercentage?: number | null
  co2ePercentage?: number | null
}

export const sharedColDefs: readonly GridColDef<Row>[] = [
  {
    field: 'co2e',
    headerName: 'Utsläpp',
    type: 'number',
    valueFormatter: (v: number) => getNumberFormatter([v]).format(v),
    flex: 1,
  } as const,
  {
    field: 'co2ePercentage',
    headerName: '% Utsläpp',
    type: 'number',
    valueFormatter: (v: number) => `${v.toFixed(0)}%`,
    flex: 1,
  } as const,
  {
    field: 'kr',
    headerName: 'Kr',
    type: 'number',
    valueFormatter: (v: number) => {
      // Render kr using Swedish locale, i.e. separate thousands with space.
      // Rounded to whole kr.
      return `${Math.round(v).toLocaleString('sv-SE')} kr`
    },
    flex: 1,
  } as const,
  {
    field: 'krPercentage',
    headerName: '% Kr',
    type: 'number',
    valueFormatter: (v: number) => `${v.toFixed(0)}%`,
    flex: 1,
  } as const,
  {
    field: 'intensity',
    headerName: 'Intensitet',
    type: 'number',
    valueFormatter: (v: number) =>
      getNumberFormatter([v], {
        filter: { referenceValue: RefernceValueFilter.Revenue },
      }).format(v),
    flex: 1,
  } as const,
] as const
